export default __webpack_public_path__ + "static/media/rnr-sports-table-11.72981ded.webp";